import React from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DyamicDropdown';
import { useFilters } from '../FilterContext';
import { useServiceStatuses, GROUP_MEMBERS } from './hooks/useServiceStatuses';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const ServiceStatusFilter = () => {
  const { filterValues, updateFilter, isShowAll } = useFilters();
  const showAllEnabled = isShowAll('serviceStatus');
  const serviceStatuses = useServiceStatuses(showAllEnabled);

  useFilterInitialization('serviceStatus', serviceStatuses, {
    waitForData: true,
    persistAll: true,
    getDefaultValue: () => GROUP_MEMBERS.find(member => member.name === "Not Complete"),
    getParams: (item) => {
      // For grouped selections (Complete/Not Complete), use empty status with statusType
      if (item.id === 1 || item.id === 2) {
        return {
          status: "",
          statusType: item.id === 1 ? "C" : "O"
        };
      }
      // For Show All
      if (item.id === "") {
        return { status: "", statusType: "" };
      }
      // For individual status selections (character IDs), use the ID directly with empty statusType
      return {
        status: item.id,
        statusType: ""
      };
    }
  });

  if (!filterValues.serviceStatus) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={serviceStatuses}
        columns={[{ name: 'name', id: 1, minWidth: '130px' }]}
        columnsMinWidths={[140, 140, 140, 140, 140]}
        showHeader={false}
        width="100%"
        placeholder="Select Status"
        onChange={item => {
          let params;
          // For grouped selections (Complete/Not Complete), use empty status with statusType
          if (item.id === 1 || item.id === 2) {
            params = {
              status: "",
              statusType: item.id === 1 ? "C" : "O"
            };
          }
          // For Show All
          else if (item.id === "") {
            params = { status: "", statusType: "" };
          }
          // For individual status selections (character IDs), use the ID directly with empty statusType
          else {
            params = {
              status: item.id,
              statusType: ""
            };
          }
          updateFilter('serviceStatus', item, params, true);
        }}
        selectdValueToshow="name"
        selectedValue={filterValues.serviceStatus?.value}
        label="Filter by Status"
        isServerSide={false}
        icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
        required={false}
        showBorderColor
        groupBy={[
          { ...SHOW_ALL_OPTION, statusType: "" },
          ...GROUP_MEMBERS,
        ]}
        hasGroup
      />
    </Grid>
  );
}; 
